<ng-container *ngIf="soilWebProperties && soilWebProperties.Error">
    <h4 class="bk-soil-error-warning">
        <mat-icon>error</mat-icon>Soil data is not available for this location</h4>
    <p class="bk-soil-error-warning">
        You may have entered invalid coordinates or the Soil Web server is currently
        busy. Make sure your coordinates are in the United States. If your coordinates
        are valid, please wait a few minutes, and try again.
    </p>
</ng-container>
<form *ngIf="soilWebProperties && !soilWebProperties.Error"
    [formGroup]="soilPropertiesFormBuilder.form">
    <h4 class="bk-modal__right-title">
        {{soilWebProperties.Record.Name}}
    </h4>
    
    <ng-container *ngIf="soilWebProperties && soilWebProperties.Record && soilWebProperties.Record.Series">
        <span class="bk-soil-properties__label">
            {{'Soil Series' | translate }}
        </span>
        <div class="bk-soil-properties__label-div">
            {{ soilWebProperties.Record.Series }}
        </div>
    </ng-container>
    
    <ng-container *ngIf="soilWebProperties.Record.Texture">
        <span class="bk-soil-properties__label">
            {{'Soil Texture' | translate }}
        </span>
        <div class="bk-soil-properties__label-div">
            {{ soilWebProperties.Record.Texture }}
        </div>
    </ng-container>
 
    <!--
    <a *ngIf="soilWebProperties && soilWebProperties.Record && soilWebProperties.Record.CoKey" 
        href="http://casoilresource.lawr.ucdavis.edu/soil_web/property_with_depth_table.php?cokey={{soilWebProperties.Record.CoKey}}"
        target="_blank"
        class="bk-soil-type__source-properties-link">
        {{'View Soil Properties' | translate }}
    </a>
    -->

    <br>

    <table class="bk-modal__table bk-modal__soil-table">
        <thead>
            <tr class="bk-modal__soil-table--row bk-modal__soil-table--head">
                <th class="bk-modal__soil-table--column-one">
                    &nbsp;
                </th>

                <th *ngFor="let depth of depths"
                    class="bk-modal__soil-table--columm">
                    {{ depth }} {{ 'ft' | translate }}
                </th>
            </tr>
        </thead>
        
        <tbody>
            <tr *ngFor="let property of soilDisplayProperties"
                class="bk-modal__soil-table--row">

                <td class="bk-modal__soil-table--column-one">
                    <strong>{{ property.display | translate }} ({{ property.unit }})</strong>
                </td>
                
                <ng-container *ngFor="let layer of f.Layers.controls">
                    <td *ngIf="(layer.get('Depth').value <= depths.length) && layer.get([property.key])"
                        class="bk-modal__soil-table--columm">
                        <span *ngIf="!isEditMode">
                            {{ layer.get([property.key]).value }}
                        </span>
                        
                        <input *ngIf="isEditMode"
                            type="number"
                            class="bk-modal__soil-table--input"
                            [formControl]="layer.get([property.key])"/>

                        <span class="bk-soil-property-diff">
                            {{ getDiff(layer.get('Depth').value, property.key) | number: '1.0-2' }}&nbsp;
                        </span>
                    </td>
                </ng-container>
            </tr>

            <tr *ngIf="depths && depths.length > 0"
                class="bk-modal__soil-table--row">
                <td class="bk-modal__soil-table--column-one">
                    <strong>{{ 'Mineralization' | translate }} lb/acre/day</strong>
                </td>
                <td class="bk-modal__soil-table--columm"
                    [attr.colspan]="depths.length">
                    <span *ngIf="!isEditMode">
                        {{ f.Layers.controls[0].get('Mineralization').value }}
                    </span>
                    <input *ngIf="isEditMode"
                        class="bk-modal__soil-table--input"
                        type="number"
                        [formControl]="f.Layers.controls[0].get('Mineralization')"/>

                    <span class="bk-soil-property-diff">
                        {{ getDiff(1, 'Mineralization') | number: '1.0-2' }}&nbsp;
                    </span>
                </td>
            </tr>
        </tbody>
        
    </table>

    <div class="bk-soil-properties-table__bottom_UI">
        <button class="cm-plain-button"
            *ngIf="!isEditMode"
            (click)="enableEdit()">
            <mat-icon>edit</mat-icon> {{ 'Edit Soil Composition' | translate }}
        </button>
        <button class="cm-plain-button"
            *ngIf="isEditMode"
            (click)="cancelEdit()">
            <mat-icon>arrow_back</mat-icon> {{ 'Exit Edit Mode' | translate }}
        </button>
        <div *ngIf="soilPropertiesFormBuilder.areSoilLayersCustomized"
            (click)="resetSoilProperties($event)"
            class="bk-edit-link"
            matTooltip="Reset custom values to soil properties published on SoilWeb">
            <mat-icon>replay</mat-icon>
            <span>
                {{'Reset Soil Properties' | translate }}
            </span>
        </div>
    </div>
</form>